import { SET_MAIN_MENU, SET_IS_VIEW_ALL_EXPERTISE } from "@/store/actions.type";

const state = {
  mainMenu: [],
  isViewAllExpertise: 0
};

const getters = {
  mainMenu(state) {
    return state.mainMenu;
  },
  getCheckAllExpertiseRoute(state) {
    return state.isViewAllExpertise;
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const actions = {
  [SET_MAIN_MENU]({ state }, elems) {
    state.mainMenu = elems;
  },
  [SET_IS_VIEW_ALL_EXPERTISE]({ state }, bool) {
    state.isViewAllExpertise = bool;
  }
};

export default {
  state,
  getters,
  actions
};
